import { computed, type Ref } from 'vue';
import type { GroupIn, Chip } from '@/entities/tour-activities';
import { useCategoryStore } from '@/shared/store';

export function useToursActivitiesAsChipsGroups(): Ref<GroupIn[]> {
  const categoryStore = useCategoryStore();

  const groups = computed<GroupIn[]>(() => {
    const map = new Map<string, Chip[]>();

    for (const a of categoryStore.toursActivities) {
      const title = a.categoryTitle || '';
      const list = map.get(title) ?? [];

      list.push({
        label: a.name ?? '',
        value: a.slug ?? '',
        id: a.id,
      });

      map.set(title, list);
    }

    return Array.from(map.entries()).map(([title, tags]) => ({ title, tags }));
  });

  return groups as Ref<GroupIn[]>;
}
